


import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from 'react-router-dom';
import ManagerHeader from "./ManagerHeader";
import Navbar from "./Navbar";

const PendingRequest = () => {
  const [profilecard, setProfilecard] = useState([]);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage, setCardsPerPage] = useState(6);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("mangertoken");
    if (!token) {
      navigate('/ManagerLogin');
      return;
    }
  }, [navigate]);

  useEffect(() => {
    fetch("https://server-side-influencer.onrender.com/brand/messages")
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setProfilecard(data.data);
        }
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setCardsPerPage(6);
      } else {
        setCardsPerPage(3);
      }
      setIsSmallScreen(window.innerWidth <= 780);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCardClick = (brandData) => {
    navigate('/requestpage', { state: { brandData } });
  };

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  const currentCards = profilecard.slice(indexOfFirstCard, indexOfLastCard);
  const totalPages = Math.ceil(profilecard.length / cardsPerPage);

  return (
    <div className="flex h-screen mb-0">
      <div className="text-white fixed top-0 left-0 bottom-0 z-10">
        <Navbar />
      </div>

      <div className="h-screen ml-0 max-sm:ml-0 w-screen">
        <ManagerHeader page="influencers requirements" />

        <div
          className="flex flex-col w-full flex-grow p-8 items-center"
          style={{
            marginTop: isSmallScreen ? '90px' : '60px',
            marginLeft: isSmallScreen ? '0px' : '58px',
          }}
        >
          <h2 className="text-center font-bold text-xs sm:text-2xl md:text-3xl mb-5">
            Unlock Exclusive Influencer Requirements from Leading Brands
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 justify-center w-full mt-10">
            {loading ? (
              [...Array(cardsPerPage)].map((_, index) => (
                <div key={index} className="max-w-[600px] w-full h-[380px] bg-white rounded-3xl shadow-lg p-6">
                  <Skeleton height="50%" className="mb-6" />
                  <div className="flex items-center mt-[-40px] ml-4">
                    <Skeleton circle width={56} height={56} />
                    <Skeleton width={120} height={24} className="ml-3" />
                  </div>
                  <Skeleton width={100} height={20} className="mt-4 mx-auto" />
                </div>
              ))
            ) : profilecard.length === 0 ? (
              <h1 className="text-2xl font-bold text-center text-gray-600 col-span-full">No Requirements Found</h1>
            ) : (
              currentCards.map((item, index) => (
                 <div
        key={index}
        className="relative max-w-[580px] w-full h-[380px] bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition duration-300 mb-4"
        onClick={() => handleCardClick(item)}
      >
                  <div className="h-1/2 bg-gray-200 relative">
                    <div
                      className="h-full w-full bg-cover bg-center"
                      style={{ backgroundImage: `url(${item.brandbackgroundimage})` }}
                    >
                      <div className="absolute inset-0 bg-black/30" />
                    </div>
                  </div>

                  <div className="absolute left-4 top-[47%] z-0 transform translate-y-1/2 flex items-center">
                    <img
                      src={item.brandLogo}
                      alt="Brand Logo"
                      className="w-14 h-14 rounded-full border-2 border-white shadow-md bg-white object-cover"
                    />
                    <h3 className="ml-3 text-lg font-bold text-gray-800">{item.shopName}</h3>
                  </div>

                  <div className="p-4 pt-6 flex flex-col gap-2 relative h-1/2 mt-4">
                    <h3 className="text-lg font-bold text-gray-800 mt-8 text-center">{item.brandType}</h3>
                    <div className="flex items-center text-sm text-gray-600 mt-1 justify-center">
                      <p className="text-gray-700 font-semibold text-md">
                        Required Influencers: {item.influencerCount}
                      </p>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          {profilecard.length > cardsPerPage && (
            <div className="flex justify-center mt-6 space-x-2">
              {currentPage > 1 && (
                <button
                  onClick={() => setCurrentPage(currentPage - 1)}
                  className="px-4 py-2 border rounded-md text-gray-800 hover:bg-gray-200"
                >
                  &lt;
                </button>
              )}
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentPage(index + 1)}
                  className={`px-4 py-2 border rounded-md ${
                    currentPage === index + 1
                      ? 'bg-indigo-500 text-white'
                      : 'text-gray-800 hover:bg-gray-200'
                  }`}
                >
                  {index + 1}
                </button>
              ))}
              {currentPage < totalPages && (
                <button
                  onClick={() => setCurrentPage(currentPage + 1)}
                  className="px-4 py-2 border rounded-md text-gray-800 hover:bg-gray-200"
                >
                  &gt;
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PendingRequest;

